export default "__VITE_ASSET__40563bfc__"